import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

export type CompetencyScoreDto = {
  id: string;
  companyId: string;
  userId: string;
  competencyId: string;
  score: number;
  source: string;
  sourceRefId: string | null;
  assessedAt: string;
  createdAt: string;
};

export async function listScoresForUser(
  userId: string,
  companyId: string,
  latest = true,
) {
  const res = await apiFetch(
    `${API_BASE_URL}/api/competency-scores/user/${userId}?companyId=${companyId}&latest=${latest}`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.json() as Promise<{ success: boolean; data?: { scores: CompetencyScoreDto[] }; error?: string }>;
}

export async function recordCompetencyScore(
  input: {
    companyId: string;
    userId: string;
    competencyId: string;
    score: number;
    source: string;
    sourceRefId?: string;
  },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/competency-scores`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { score: CompetencyScoreDto }; error?: string }>;
}

export async function deleteCompetencyScore(scoreId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/competency-scores/${scoreId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}
